var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar clearfix"},[_c('el-breadcrumb',{staticClass:"breadcrumb-container",attrs:{"separator-class":"el-icon-arrow-right"}},_vm._l((_vm.levelList),function(item){return _c('el-breadcrumb-item',{key:item.name,attrs:{"to":item.meta.redirect}},[_vm._v(_vm._s(item.meta.title))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }